import { FC } from 'react';

interface ViewIconProps {
  className?: string;
  active?: boolean;
}

export const GridIcon: FC<ViewIconProps> = ({ className = '', active = false }) => (
  <svg 
    className={`${className} ${active ? 'text-[#00FF84]' : 'text-gray-400'}`}
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <rect x="3" y="3" width="7" height="7" />
    <rect x="14" y="3" width="7" height="7" />
    <rect x="14" y="14" width="7" height="7" />
    <rect x="3" y="14" width="7" height="7" />
  </svg>
);

export const TableIcon: FC<ViewIconProps> = ({ className = '', active = false }) => (
  <svg 
    className={`${className} ${active ? 'text-[#00FF84]' : 'text-gray-400'}`}
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M3 3h18v18H3zM3 9h18M3 15h18M9 9v12M15 9v12" />
  </svg>
); 